<template>
    <div>
        <header>
            <img src="../assets/img/myCenter/afterSalesHeader@3x.png" alt="">
        </header>
        <van-cell-group>
            <van-cell title="申请退货" is-link @click="openRefund" value="" v-if="refundShow" size="large"/>
            <van-cell title="申请安装"  v-if="setupOrRepairedShow" is-link @click="esvOpenPage({name: 'OPApplyAfterSales',query: { type: 'install' }})" value="" size="large"/>
            <van-cell title="申请维修" is-link v-if="setupOrRepairedShow" @click="esvOpenPage({name: 'OPApplyAfterSales',query: { type: 'repair' }})" value="" size="large"/>
            <van-cell title="查看售后历史" is-link @click="esvOpenPage({name: 'OPAfterSalesList',query: { type: 'order' }})" value="" size="large"/>
        </van-cell-group>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
export default {
    esvShow() {

    },
    esvReady() {
        // this.getMerchantInfo();
    },
    data() {
        return {
            // merchantInfo: {}
        };
    },
    methods: {
        // getMerchantInfo() {
        //     this.ESVStorage.getSessionValue('merchantInfo', (merchantInfo) => {
        //         if (merchantInfo) {
        //             this.merchantInfo = merchantInfo;
        //         } else {
        //             this.$doRequest(
        //                 { url: '/merchant/getMerchantInfo', params: {} },
        //                 (data) => {
        //                     this.merchantInfo = data.result;
        //                     this.ESVStorage.putSessionValue('merchantInfo', this.merchantInfo);
        //                 }
        //             );
        //         }
        //     });
        // },
        openRefund() {
            this.esvOpenPage({ name: 'OPRefund', query: { type: '2' } });
        }
    },
    computed: {
        ...mapState({
            choiceGoodsItem: state => state.order.choiceGoodsItem,
            orderDetails: state => state.order.orderDetails
        }),
        ...mapGetters(
            ['merchantInfo']
        ),
        setupOrRepairedShow() {
            return this.choiceGoodsItem.serviceFlag === 2 && this.choiceGoodsItem.productBusinessType !== 2 && Number(this.merchantInfo.isSupportCis) === 1; ;
        },
        refundShow() {
            // finishFlag 0 可退换 1已完结 2 已锁定
            return this.orderDetails.lockFlag === 0 && this.orderDetails.finishFlag === 0 && Number(this.merchantInfo.isSupportReturn) === 1;
        }
    }
};
</script>

<style scoped lang="scss">
header {
    width: 100%;
    padding: 8px 15px 0;
    background-color: #fff;
    margin-bottom: 8px;
    img {
        width: 100%;
        display: block;
    }
}
</style>
